import PropTypes from 'prop-types';

export const variantShape = PropTypes.oneOf(['dialog', 'inline', 'static']);
